export const RecordEN = {
    "assetConfig": {
        "codeStructure": "Code structure",
        "codeStructureDetail1": "Use keywords {keyword} to write ID generated in the predefined format",
        "codeStructureDetail2": "See a list of usable keywords",
        "counting": "Auto increment counter starts from",
        "countingDetail": "Auto increment ID counter can be set from 0 or greater than.",
        "allowedEdit": "Allow editing",
        "allowedEditDetail1": "When this feature is enabled, users can change the ID",
        "allowedEditDetail2": "Please disable it if your company already has a standardized ID, avoiding ID conflicts between objects.",
        "title1": "Mã cài đặt tài sản",
        "title2": "Mã cài đặt cấp phát",
        "title3": "Mã cài đặt thu hồi",
        "labelAsset": "NHÃN TÀI SẢN",
        "titleModal": "Auto code keyword",
        "titleColumn1": "Key word",
        "titleColumn2": "Description",
        "titleModalLabel": "Create a new label"
    },
    "employeeConfigLabel": {
        "benefit": "Manager benefit",
        "contractType": "Contract type",
        "employeeConfig": "Personel profile",
        "employeeContractConfig": "Labor contract",
        "fineConfig": "Fine config",
        "jobPosition": "Job position",
        "jobTitle": "Job title",
        "employmentType" : " Config employment type ",
        "workplace": "Workplace config",
        "welfare": "Welfare config",
        "categoryConfig": "Category",
        "award": "Reward & welfare"
    },
    "employeeConfig": {
        "employeeConfigHeader": "Personel profile setting",
        "employeeConfigSettingPatternCode": "Pattern code setting",
        "codePattern": "Pattern code",
        "codePatternDetail": "Use keywords {keyword} to write auto-generated code in the available format",
        "codePatternShow": "See a list of usable keywords",
        "viewOrUpdateInfoSalary": "Right to view/edit salary and allowance information in personel profile",
        "viewOrUpdateInfoSalaryDetail": "Those with this permission will be able to view/edit the salaries and allowances of the respective department",
        "viewOrUpdateInfoInsurance": "Right to view/edit insurance information in personel profile",
        "viewOrUpdateInfoInsuranceDetail": "Persons with this permission will be able to view/edit the insurance information of the respective department",
        "allowedUpdateInfo": "Allow employees to update personal information by themselves",
        "allowedFieldUpdate": "Personel fields are allowed to update information",
        "allowedFieldUpdateDetail": "When the installation is complete, users can update these data fields on their personal page. However, it is only updated to the data when the personel profile is approved",
        "setting": "Setting",
        "all": "All",
        "managerAll": "Manager all",
        "company": "Manager company",
        "branch": "Manager branch",
        "department": "Manager department",
        "award": "Config bonus / welfare",
        "position": "Config position",
        "positiontitle": "Config position title",
        "workplace": "Config workplace",
        "penance": "Config penance",
        "countDescription": "The object's self-incrementing counter, use {count} or alternatively you can format additional \"0\" characters in front, for example {count,5} will display 00005",
        "userPersonCode": "User ID of the creator",
        "userDepartmentCode": "The creator's department code",
        "dateDescription1": "Get the current time value, format as needed.",
        "dateDescription2": "For example: {date,ddMMyyyy} would display as 05122021.",
        "dateDescription3": "The characters used for formatting include:",
        "dateDescription4": "dd: date in 2-digit format",
        "dateDescription5": "MM: month in 2-digit format",
        "dateDescription6": "yy: year in 2-digit format",
        "dateDescription7": "yyyy: year in 4-digit format",
        "departmentCode": "The department code of the personnel assigned to the contract",
        "personCode": "Personnel code assigned to the contract",
        "contractCount": "Contract number of the employee to whom the contract was created, 2-digit format.",

        "employeeContractConfig": "Labor contract",

        "insuranceConfig": "Insurance Config",
        "insuranceConfigConditionsForIncreaseInsurance": "Conditions For Increase Insurance",
        "closingDateForMonthlyIncrease": "Closing date for monthly increase",
        "conditionsForIncreaseInsurance1": "Increasing the number of employees paying social insurance, health insurance and unemployment insurance premiums in this case is understood as an increase in the number of employees participating in paying social insurance, health insurance and unemployment insurance premiums.",
        "conditionsForIncreaseInsurance2": "Increments before this date will be reported for this month, and after this date will be reported for the next month.",
        "signEmployeeContract": "Sign Employee Contract",
        "backToWorkMaternity": "Back to work maternity",
        "backToWorkUnpaid": "Back to work unpaid",
        "incrementAmount": "Increment Amount",
        "insuranceConfigConditionsForDecreaseInsurance": "Conditions for decrease insurance",
        "closingDateForMonthlyDecrease": "Closing date for monthly decrease",
        "conditionsForDecreaseInsurance1": "Reducing employees paying social insurance, health insurance and unemployment insurance premiums in this case is understood as reducing the number of employees participating in paying social insurance, health insurance and unemployment insurance premiums",
        "conditionsForDecreaseInsurance2": "Any decrease before this date will report a decrease for this month, and after this date will report a decrease for the next month.",
        "decrementReSign": "Employee contract with unemployment insurance",
        "offWorkMaternity": "Off work maternity",
        "decrementAmount": "Decrement amount",
        "decrementAmountContent": "In case the employee does not work and does not receive a salary for more than the maximum number of days off every month, he/she will not pay social insurance premiums for that month. This time is not counted to enjoy social insurance.",
        "offWorkUnpaid": "Off work unpaid",
        "unpaidMaxDay": "Unpaid max day in month",
        "insuranceRate": "Insurance Rate",
        "insuranceRateContent": "This setting will apply to all personnel records",
        "insuranceRateFromMonth": "From month",
        "insuranceAmount": "Amount",
        "socialInsuranceRate": "Social Insurance Rate",
        "accidentInsuranceRate": "Accident Insurance Rate",
        "healthInsuranceRate": "Health Insurance Rate",
        "unemploymentInsuranceRate": "Unemployment Insurance Rate",
        "totalInsuranceRate": "Total",
        "placeholderAmount": "Money",
        "placeholderCompany": "COM",
        "placeholderEmployee": "EMP",
        "autoCalculate": "Automatically recalculate coverage from current month",
        "autoCalculateContent": "The gray boxes are the % paid by employees"
    },
    "penanceConfig": {
        "headingLabel": "Penance config",
        "active": "Active",
        "inactive": "In-active",
        "update": "Update",
        "penanceConfigColumns": {
            "name": "Violation error",
            "amount": "Amount",
            "status": "Status"
        }
    },
    "awardConfig": {
        "headingLabel": "Reward & welfare",
        "active": "Active",
        "inactive": "In-active",
        "update": "Update",
        "awardConfigColumns": {
            "name": "Name",
            "amount": "Amount",
            "status": "Status",
            "desc": "Description"
        }
    },
    "fineConfig": {
        "add": "Add new fine config"
    }
}